import { $$, on, setAttr } from "../../utils/dom";

export const onContentLoaded = (): void => {
  function toggle(e: Event) {
    const toggleButton = e.target as HTMLButtonElement;

    if (toggleButton) {
      const toggleState =
        toggleButton.getAttributeNode("aria-pressed")?.value === "false"
          ? "true"
          : "false";

      setAttr(toggleButton, "aria-pressed", toggleState);
      setAttr(toggleButton, "js-open-all", toggleState);
    }
  }

  const toggleButtons = $$(".js-toggle-button");
  toggleButtons?.forEach((button) => on(button, "click", toggle));
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
